/* eslint-disable no-undef */
import React, { useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import useWindowWidth from '../../hooks/useWindowWidth';
import { AuthContext } from '../../contexts/AuthProvider';

import Translate from '../../i18n/Translate';
import SocialMedia from '../../components/icons/SocialMedia';
import Prices from '../Header/components/Prices';
import PrivateLink from '../../components/PrivateLink';
// import Flags from '../header/components/Flags';
import {
  PlaneIcon,
  BoatIcon,
  LocationIcon,
  PaymentIcon,
  DisneyIcon,
  FlyersIcon,
  StarIcon,
  ArrowDownIcon,
  NacionalIcon,
} from '../../components/icons';

import color from '../../assets/scss/variables/colors.module.scss';

const Menu = ({ isMenuOpen, setIsMenuOpen }) => {
  const { user } = useContext(AuthContext);

  const aereosUrl = process.env.REACT_APP_AEREOS_URL;
  const aereosPass = process.env.REACT_APP_AEREOS_PASS;
  const disneyUrl = process.env.REACT_APP_DISNEY_URL;
  const nacionalUrl = process.env.REACT_APP_NACIONAL_URL;
  const reservasUrl = process.env.REACT_APP_RESERVAS_URL_NEMO;

  const { colorSecundario } = color;
  const { t } = useTranslation();
  const width = useWindowWidth();

  useEffect(() => {
    if (isMenuOpen || !isMenuOpen || width > 992) {
      document.body.style.overflow = 'auto';
    }
  }, [isMenuOpen, width]);

  useEffect(() => {
    if (!isMenuOpen) {
      document.body.style.overflow = 'auto';
    } else {
      document.body.style.overflow = 'hidden';
    }
  }, [isMenuOpen]);

  return (
    <nav className={`menu ${isMenuOpen && 'opened'}`}>
      <div className='menu__container'>
        <Prices />
        <br />

        <ul className='menu__container__list'>
          {/* Cuenta */}
          {/* {user.isAuthenticated && (
						<>
							<li className='menu__container__item'>
								<Link onClick={() => setIsMenuOpen(!isMenuOpen)} to='/' className='menu__link'>
									<UserIcon />
									<Translate langkey='links.option8' />
								</Link>
							</li>
							<br />
						</>
					)} */}

          {/* Aereos */}
          <li className='menu__container__item'>
            <PrivateLink
              href={`${aereosUrl}`}
              className='menu__link'
              isAuthenticated={user.isAuthenticated}
              onClick={() => {
                return setIsMenuOpen(!isMenuOpen);
              }}
            >
              <PlaneIcon />
              <Translate langkey='links.option1' />
            </PrivateLink>
          </li>

          {/* Cruceros */}
          <li className='menu__container__item'>
            <Link
              onClick={() => {
                return setIsMenuOpen(!isMenuOpen);
              }}
              to={`${t('routes.cruise')}`}
              className='menu__link'
            >
              <BoatIcon />
              <Translate langkey='links.option2' />
            </Link>
          </li>

          {/* Disney */}
          <li className='menu__container__item'>
            <PrivateLink
              href={`${disneyUrl}975`}
              className='menu__link'
              isAuthenticated={user.isAuthenticated}
              onClick={() => {
                return setIsMenuOpen(!isMenuOpen);
              }}
            >
              <DisneyIcon />
              <Translate langkey='links.option5.title' />
            </PrivateLink>
          </li>

          {/* Circuitos */}
          <li className='menu__container__item'>
            <Link
              onClick={() => {
                return setIsMenuOpen(!isMenuOpen);
              }}
              to={`${t('routes.circuits')}`}
              className='menu__link'
            >
              <LocationIcon />
              <Translate langkey='links.option3' />
            </Link>
          </li>

          {/* Nacional */}
          <li className='menu__container__item'>
            <PrivateLink
              href={`${nacionalUrl}${user.credentials}`}
              className='menu__link'
              isAuthenticated={user.isAuthenticated}
              onClick={() => {
                return setIsMenuOpen(!isMenuOpen);
              }}
            >
              <NacionalIcon />
              <Translate langkey='links.option10' />
            </PrivateLink>
          </li>

          {/* Collection */}
          <li className='menu__container__item'>
            <div className='menu__container__item__dropdowns'>
              <button>
                <StarIcon />
                <Translate langkey='links.option7.title' />
                <ArrowDownIcon className='arrowDownIcon' />
              </button>

              <div className='menu__container__item__dropdowns__content'>
                <Link
                  onClick={() => {
                    return setIsMenuOpen(!isMenuOpen);
                  }}
                  to={`${t('routes.weddings')}`}
                >
                  <Translate langkey='links.option7.link2' />
                </Link>
                <a
                  onClick={() => {
                    return setIsMenuOpen(!isMenuOpen);
                  }}
                  href={`${t('routes.fifteenyears')}`}
                  target='_blank'
                  rel='noreferrer'
                >
                  <Translate langkey='links.option7.link5' />
                </a>
              </div>
            </div>
          </li>

          {/* Flyers */}
          <li className='menu__container__item'>
            <Link
              onClick={() => {
                return setIsMenuOpen(!isMenuOpen);
              }}
              to={`${t('routes.flyers')}`}
              className='menu__link'
            >
              <FlyersIcon />
              <Translate langkey='links.option6' />
            </Link>
          </li>

          {/* formas de pago */}
          <li className='menu__container__item'>
            <div className='menu__container__item__dropdowns'>
              <button>
                <PaymentIcon />
                <Translate langkey='links.option4.title' />
                <ArrowDownIcon className='arrowDownIcon' />
              </button>

              <div className='menu__container__item__dropdowns__content'>
                <span className='triangle' />

                <Link
                  onClick={() => {
                    return setIsMenuOpen(!isMenuOpen);
                  }}
                  to={`${t('routes.airlinecompanies')}`}
                  className='menu__link'
                >
                  <Translate langkey='links.option4.link1' />
                </Link>

                <Link
                  onClick={() => {
                    return setIsMenuOpen(!isMenuOpen);
                  }}
                  to={`${t('routes.towertravel')}`}
                  className='menu__link'
                >
                  <Translate langkey='links.option4.link2' />
                </Link>

                <a
                  onClick={() => {
                    return setIsMenuOpen(!isMenuOpen);
                  }}
                  href={`${t('routes.paymentmethods')}`}
                  target='_blank'
                  rel='noreferrer'
                  className='menu__link'
                >
                  <Translate langkey='links.option4.link3' />
                </a>
              </div>
            </div>
          </li>
        </ul>

        <br />
        {/* RESERVAS ONLINE */}

        <PrivateLink
          href={`${reservasUrl}`}
          className='callToAction'
          isAuthenticated={user.isAuthenticated}
          onClick={() => {
            return setIsMenuOpen(!isMenuOpen);
          }}
        >
          <Translate langkey='links.reservas_online' />
        </PrivateLink>

        <br />

        <div className='menu__container__social'>
          <SocialMedia fill={colorSecundario} background='transparent' />
        </div>

        <br />
        <div className='menu__container__flags'>{/* <Flags /> */}</div>
      </div>
    </nav>
  );
};

export default Menu;
